import { Card, CardBody, Row } from "reactstrap";
import { useHistory, useLocation } from "react-router-dom";
import FacultyMultiSelect from "./FacultyMultiSelect";
import InputField from "./InputField";
import SelectField from "./SelectField";
import TextareaField from "./TextareaField";
import styles from "./index.module.scss";
import Participants from "./Participants";
import RelatedItems from "./RelatedItems";
import InputDate from "./InputDate";

const SessionForm = ({
  sessionData,
  teamState,
  handleForm,
  handleFacultyForm,
  handleRelatedChange,
  ...props }) => {
  const {
    sessionTitle,
    _id: id,
    startDate,
    room,
    startTime,
    endTime,
    zoomUrl,
    registrationURL,
    sessionStatus,
    sessionPrivacy,
    sessionType,
    sessionDescription,
    participants,
    related,
    classReminder,
  } = sessionData;

  const statusOptions = ["Active", "Hidden"];
  const privacyOptions = ["Open", "Registered Only", "Canceled"];
  const classReminderOptions = ["No reminder", "Notification only", "Email only", "Notification and Email"];
  const typeOptions = [
    "Elective",
    "Evening Session",
    "Lecture",
    "Meal",
    "Opening Circle",
    "Plenary",
    "Processing Session",
    "Tiyul",
    "Prayer",
    "Workshop",
    "Break",
    "Shabbat",
    "Other",
  ];

  return (
    <Card>
      <CardBody>
        <h2 className={styles.title}>{`Edit Session:   ${sessionTitle || ""}`}</h2>
        <Row>
          <FacultyMultiSelect
            selectedFacultyUsers={teamState}
            handleFacultyForm={handleFacultyForm}
          />
        </Row>
        <Row>
          <InputField
            label="Title"
            value={sessionTitle}
            id="_title"
            type="text"
            onChange={(value) => {
              handleForm({ sessionTitle: value });
            }}
            isFullWidth
          />
        </Row>
        <Row>
          <InputField
            label="Date"
            value={startDate}
            id="_startDate"
            type="date"
            onChange={(value) => {
              handleForm({ startDate: value });
            }}
          />
          <InputField
            label="Room"
            value={room || ""}
            id="_room"
            type="text"
            onChange={(value) => {
              handleForm({ room: value });
            }}
          />
        </Row>
        <Row>
          <InputDate
            label="Start Time"
            value={startTime}
            id="_startTime"
            onChange={(value) => {
              handleForm({ startTime: value });
            }}
          />
          <InputDate
            label="End Time"
            value={endTime}
            id="_endTime"
            onChange={(value) => {
              handleForm({ endTime: value });
            }}
          />
        </Row>
        <Row>
          <InputField
            label="Zoom"
            value={zoomUrl || ""}
            id="_zoomUrl"
            type="text"
            onChange={(value) => {
              handleForm({ zoomUrl: value });
            }}
          />
          <InputField
            label="Registration"
            value={registrationURL || ""}
            id="_registrationURL"
            type="text"
            onChange={(value) => {
              handleForm({ registrationURL: value });
            }}
          />
        </Row>
        <Row>
          <SelectField
            label="Status"
            options={statusOptions}
            value={sessionStatus}
            onChange={(value) => handleForm({ sessionStatus: value })}
          />
          <SelectField
            label="Privacy"
            options={privacyOptions}
            value={sessionPrivacy || ""}
            onChange={(value) => handleForm({ sessionPrivacy: value })}
          />

          <SelectField
            label="Type"
            options={typeOptions}
            value={sessionType || ""}
            onChange={(value) => handleForm({ sessionType: value })}
          />
        </Row>
        <Row>
          <SelectField
            label="Class Reminder"
            options={classReminderOptions}
            value={classReminder || ""}
            onChange={(value) => handleForm({ classReminder: value })}
          />
        </Row>
        <Row>
          <TextareaField
            label="Description"
            value={sessionDescription}
            onChange={(value) => handleForm({ sessionDescription: value })}
          />
        </Row>
        <div className={styles.border} />

        <Row className="mt-4">
          <RelatedItems
            related={related}
            handleRelatedChange={handleRelatedChange}
          />
        </Row>
        <Row className="mt-3">
          <Participants
            participants={participants}
            sessionId={id}
            {...props}
          />
        </Row>
      </CardBody>
    </Card>
  );
};

export default SessionForm;